import React from 'react';
import {connect} from 'react-redux'
import Paper from 'material-ui/Paper';

import { formValueSelector, isDirty } from 'redux-form'

import {Link} from 'react-router-dom'

import PageBase from '../../components/PageBase';
import YosanForm from './YosanForm'

import gStyles from '../../styles'

import * as actions from '../../actions'

import $ from 'jquery'
import _ from 'lodash'
import moment from "./YosanListPage";


const dateConvert = (year, month) => {

  if (!year) {
    return
  }

  if (!month) {
    return moment().year(year).month(0).date(1)
  }

  return moment().year(year).month(month - 1).date(1)

}

class YosanPage extends React.Component {

  componentDidMount() {
    const {
      match, history
    } = this.props

    let id;
    if (match.params.id) {
      id = match.params.id + (history.location.search || '')
    }

    this.props.init(id)

    this.unblock = this.props.history.block((location, action) => {
      if (this.props.dirty) {
        return '入力した情報は保存されません。よろしいですか？'
      }
    })

  }

  componentWillUnmount() {
    this.unblock()
  }

  componentDidUpdate() {
    const {
      history,
      transition
    } = this.props

    if (transition) {
      history.push("/yosanList")
    }
  }

  render() {

    const {
      auth,
      form,
      selectData,
      kenmeiNames,
      materialCosts,
      outsourcingCosts,
      roumuCosts,
      xronosRoumuCosts,
      expenseCosts,
      orderAmmounts,
      orderAmmount,
      orderAmmountBudget,
      claimAmmounts,
      claimAmmount,
      kenmeiCode,
      match,
      handleFormRegistClick,
      handleFormDeleteClick,
      handleKenmeiChange,
      handleFormStatusClick,

      materialCostHistorys,
      roumuCostHistorys,
      xronosRoumuCostHistorys,
      outsourcingCostHistorys,
      expenseCostHistorys,

      history

    } = this.props

    const query = history.location.search.substring(1).split('&').map((p) => p.split('=')).reduce((obj, e) => ({...obj, [e[0]]: e[1]}), {});

    const startDate = query.startDate;
    const endDate = query.endDate;

    return (
      <PageBase title="実行予算" >
        <Paper style={gStyles.pageContents}>
            <YosanForm
            auth={auth}
            status={form.status}
            kenmeiData={selectData.kenmei}
            costData={selectData.cost}
            userData={selectData.user}
            initialValues={form}
            materialCosts={materialCosts}
            outsourcingCosts={outsourcingCosts}
            roumuCosts={roumuCosts}
            xronosRoumuCosts={xronosRoumuCosts}
            expenseCosts={expenseCosts}
            orderAmmounts={orderAmmounts}
            orderAmmount={orderAmmount}
            orderAmmountBudget={orderAmmountBudget}
            claimAmmounts={claimAmmounts}
            claimAmmount={claimAmmount}
            kenmeiNames={kenmeiNames}
            onKenmeiChange={handleKenmeiChange}
            onFormRegistClick={handleFormRegistClick}
            onFormDeleteClick={handleFormDeleteClick}
            onFormStatusClick={handleFormStatusClick}

            materialCostHistorys={materialCostHistorys}
            roumuCostHistorys={roumuCostHistorys}
            xronosRoumuCostHistorys={xronosRoumuCostHistorys}
            outsourcingCostHistorys={outsourcingCostHistorys}
            expenseCostHistorys={expenseCostHistorys}

            startDate={startDate}
            endDate={endDate}

          />
        </Paper>
      </PageBase>
    );

  }

}

const selector = formValueSelector('yosanForm')
const mapStateToProps = (state) => {

  const orderAmmounts = selector(state, 'orderAmmounts')
  const orderAmmount = selector(state, 'orderAmmount')
  const orderAmmountBudget = selector(state, 'orderAmmountBudget')

  const claimAmmounts = selector(state, 'claimAmmounts')
  const claimAmmount = selector(state, 'claimAmmount')

  const materialCosts = selector(state, 'materialCosts')
  const materialCostHistorys = selector(state, 'materialCostHistorys')

  const roumuCosts = selector(state, 'roumuCosts')
  const roumuCostHistorys = selector(state, 'roumuCostHistorys')

  const xronosRoumuCosts = selector(state, 'xronosRoumuCosts')
  const xronosRoumuCostHistorys = selector(state, 'xronosRoumuCostHistorys')

  const outsourcingCosts = selector(state, 'outsourcingCosts')
  const outsourcingCostHistorys = selector(state, 'outsourcingCostHistorys')

  const expenseCosts = selector(state, 'expenseCosts')
  const expenseCostHistorys = selector(state, 'expenseCostHistorys')

  return {
    auth: state.auth,
    transition: state.yosan.transition,
    form: state.yosan.form,
    selectData: state.yosan.selectData,
    kenmeiNames: state.yosan.kenmeiNames,
    materialCosts: materialCosts,
    outsourcingCosts: outsourcingCosts,
    roumuCosts: roumuCosts,
    xronosRoumuCosts: xronosRoumuCosts,
    expenseCosts: expenseCosts,
    orderAmmounts: orderAmmounts,
    orderAmmount: orderAmmount,
    orderAmmountBudget: orderAmmountBudget,
    claimAmmounts: claimAmmounts,
    claimAmmount: claimAmmount,
    materialCostHistorys: materialCostHistorys,
    roumuCostHistorys: roumuCostHistorys,
    xronosRoumuCostHistorys: xronosRoumuCostHistorys,
    outsourcingCostHistorys: outsourcingCostHistorys,
    expenseCostHistorys: expenseCostHistorys,
    dirty: isDirty('yosanForm')(state),
  }
}

const mapStateToDispatch = (dispatch) => ({
  init: (id) => {dispatch(actions.systemYosanInit(id))},
  handleFormRegistClick : (id, startDate, endDate) => (values) => {dispatch(actions.userYosanFormRegist(id, values, startDate, endDate))},
  handleFormDeleteClick : (id) => (values) => {
      if (window.confirm("実行予算を削除してもよろしいですか？")) {
          dispatch(actions.userYosanFormDelete(id, values))
      }
  },
  handleKenmeiChange : (kenmeiNames) => {
    dispatch(actions.reducerYosanSetKenmeiNames(kenmeiNames))
  },
  handleFormStatusClick : (id, statusChange) => (values) => {
    const form = {statusChange: statusChange}

    dispatch(actions.userYosanFormRegist(id, form))
  },
})

export default connect(
  mapStateToProps,
  mapStateToDispatch
)(YosanPage)




// WEBPACK FOOTER //
// ./src/containers/yosan/YosanPage.js